import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import * as queryString from "query-string";
import { AuthUsernameSuccessResponse } from "./api-response/AuthUsernameSuccessResponse";
import { AuthUsernameErrorResponse } from "./api-response/AuthUsernameErrorResponse";
import { UsersAutocompleteSuccessResponse } from "./api-response/UsersAutocompleteSuccessResponse";
import { defaultHeaders, getAuthAndDefaultHeaders } from "./apiConsts";
import { MeSuccessResponse } from "./api-response/MeSuccessResponse";
import { UsersSuccessResponse } from "./api-response/UsersSuccessResponse";
import { UserDenyResponse } from "./api-response/UserDenyResponse";
import { map } from "rxjs/operators";

export interface UpdateUserData {
  firstname?: string;
  middleName?: string;
  lastName?: string;
  gender?: string;
  birthday?: string;
  timezone?: string;
  email?: string;
  emailVerificationCode?: string;
  profileImages?: {
    source: string;
    isProfileImage: boolean;
    sortKey: number;
    facebookId?: string;
  }[];
  ambassadorGroupingName?: string;
  defaultGateway?: string;
}

export class ApiUser {
  constructor(private apiEndpoint: string) {}

  login(
    username: string,
    password: string
  ): Observable<AuthUsernameSuccessResponse | AuthUsernameErrorResponse> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/auth/username`,
      headers: defaultHeaders,
      body: {
        username,
        password,
      },
    }).pipe(map((x: any) => x.response));
  }

  me(token: string): Observable<MeSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/me`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  autocompleteUsers(
    token: string,
    organization: string,
    searchBy: string
  ): Observable<UsersAutocompleteSuccessResponse> {
    const filtersStr = queryString.stringify(
      { searchBy },
      { arrayFormat: "bracket" }
    );

    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/autocomplete/users?${filtersStr}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  users(
    token: string,
    organization: string,
    nextPageUrl: string | null = null,
    filters: any = null
  ): Observable<UsersSuccessResponse> {
    let url: string;
    let filtersStr = "";

    if (filters) {
      filtersStr = queryString.stringify(filters, { arrayFormat: "bracket" });
    }

    if (nextPageUrl) {
      url = nextPageUrl + "&" + filtersStr;
    } else {
      url = `${this.apiEndpoint}/organizations/${organization}/users?${filtersStr}`;
    }

    return ajax({
      url,
      method: "GET",
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  denyUser(
    token: string,
    organization: string,
    userId: string | number
  ): Observable<UserDenyResponse> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/organizations/${organization}/users/${userId}/deny`,
      headers: getAuthAndDefaultHeaders(token),
      body: {},
    }).pipe(map((x) => x.response));
  }

  approveUser(
    token: string,
    organization: string,
    userId: string | number
  ): Observable<UserDenyResponse> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/organizations/${organization}/users/${userId}/approve`,
      headers: getAuthAndDefaultHeaders(token),
      body: {},
    }).pipe(map((x) => x.response));
  }
}
